let BSTooltip = null
export default {
    data() {
        return {
            tooltips: null
        }
    },
    beforeMount() {
        if (typeof window !== 'undefined') {
            BSTooltip = require('bootstrap.native/dist/components/tooltip-native.esm.js')
        }
    },
    mounted() {
        this.updateTooltips()
    },
    beforeUpdate() {
        this.destroyTooltips()
    },
    beforeDestroy() {
        this.destroyTooltips()
    },
    updated() {
        this.updateTooltips()
    },
    methods: {
        updateTooltips() {
            this.tooltips = Array.from(
                this.$el.querySelectorAll('[data-toggle="tooltip"]')
            )?.map((tooltip) => new BSTooltip.default(tooltip))
        },
        destroyTooltips() {
            if (this.tooltips) {
                this.tooltips.forEach((tooltip) => tooltip.dispose())
                this.tooltips = null
            }
        }
    }
}
